import { render, staticRenderFns } from "./RunningAuctionsBanner.vue?vue&type=template&id=f034af88&scoped=true&"
import script from "./RunningAuctionsBanner.vue?vue&type=script&lang=js&"
export * from "./RunningAuctionsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f034af88",
  null
  
)

export default component.exports